import React from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { FormattedMessage } from 'react-intl';

import styles from './styles.styl';

const RoleCard = ({ title, text, id, role, onCardClick, disabled }) => {
  return (
    <div
      id={id}
      styleName={cn('root', { disabled })}
      onClick={() => onCardClick(role)}
    >
      <div styleName="row">
        <p styleName="title">
          <FormattedMessage id={title} />
        </p>
      </div>
      <p styleName="text">
        <FormattedMessage id={text} />
      </p>
    </div>
  );
};

RoleCard.propTypes = {
  onCardClick: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default CSSModules(styles, { allowMultiple: true })(RoleCard);



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentRole/RoleCard/index.jsx